import Client from './Clients/ScrapingToolsClient'
import RepoUtils from './RepoUtils'

const resource = '/catalog/brand/'
const tableResource = '/catalog/brand_table/'

export default {
    get(){
        return Client.get(resource);
    },
    get(id){
        return Client.get(resource+'?id='+id);
    },
    getTable(pageNumber,filters){
        filters.page=pageNumber;
        return Client.get(RepoUtils.parseResourceWithQueryParams(tableResource,filters));
    },
    post(payload){
        return Client.post(resource,payload);
    },
    put(id,payload){
        return Client.put(`${resource}${id}/`,payload);
    },
}